module.exports = __webpack_public_path__ + "img/20210501.089e2c96.png";